module.exports = __webpack_public_path__ + "p2_img3.jpg?8c974dd422723774bf2e21ae3d96e6bd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p2/p2_img3.jpg
// module id = 102
// module chunks = 0